'use client'

import React from 'react'
import { scrollToTop } from '../HelperFunctions'

const BackToTop = () => {
    return (
        <div
            onClick={scrollToTop}
            aria-label="back-to-top"
            className="flex items-center cursor-pointer"
        >
            Back to top
            <span className="ml-4">
                <svg width="16" height="8" fill="#6B7280" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8 1a1 1 0 0 1 .64.23l6 5a1.001 1.001 0 0 1-1.28 1.54L8 3.29 2.64 7.61a1 1 0 0 1-1.41-.15A1 1 0 0 1 1.37 6l6-4.83A1 1 0 0 1 8 1Z" fill="currentColor"></path>
                </svg>
            </span>
        </div>
    )
}

export default BackToTop